module.exports = __webpack_public_path__ + "img/gal_13.8ae58c5c.png";